import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ff/debrief/store';

export interface AppSliceState {
    toast: {
        isOpen: boolean;
        message: string;
    };
    isShareApp: boolean;
    tracklogFilter: {
        startDate: number | null;
        endDate: number | null;
        fuzzySearchTerm: string | null;
    };
}

const initialAppSliceState: AppSliceState = {
    toast: {
        isOpen: false,
        message: '',
    },
    isShareApp: false,
    tracklogFilter: {
        startDate: null,
        endDate: null,
        fuzzySearchTerm: '',
    },
};

export const appSlice = createSlice({
    name: 'AppSlice',
    initialState: initialAppSliceState,
    reducers: {
        setToastState: (state, action: PayloadAction<boolean>) => {
            state.toast.isOpen = action.payload;
        },
        setToastMessage: (state, action: PayloadAction<string>) => {
            state.toast.message = action.payload;
        },
        setFilterStartDate: (state, action: PayloadAction<number>) => {
            const currentStartDate = state.tracklogFilter.startDate;
            const currentEndDate = state.tracklogFilter.endDate;
            const newStartDate = action.payload;
            if (currentEndDate) {
                state.tracklogFilter.startDate =
                    newStartDate > currentEndDate
                        ? currentStartDate
                        : newStartDate;
            } else {
                state.tracklogFilter.startDate = newStartDate;
            }
        },
        setFilterEndDate: (state, action: PayloadAction<number>) => {
            const currentStartDate = state.tracklogFilter.startDate;
            const currentEndDate = state.tracklogFilter.endDate;
            const newEndDate = action.payload;
            if (currentStartDate) {
                state.tracklogFilter.endDate =
                    newEndDate < currentStartDate ? currentEndDate : newEndDate;
            } else {
                state.tracklogFilter.endDate = newEndDate;
            }
        },
        setFuzzySearchTerm: (state, action: PayloadAction<string>) => {
            state.tracklogFilter.fuzzySearchTerm = action.payload;
        },
    },
});

export const {
    setToastState,
    setToastMessage,
    setFilterStartDate,
    setFilterEndDate,
    setFuzzySearchTerm,
} = appSlice.actions;

export const selectFilterStartDate = (state: RootState) =>
    state.appSlice.tracklogFilter.startDate;
export const selectFilterEndDate = (state: RootState) =>
    state.appSlice.tracklogFilter.endDate;
export const selectFuzzySearchTerm = (state: RootState) =>
    state.appSlice.tracklogFilter.fuzzySearchTerm;
